import { getBoundedValue } from 'utils/math/math.utils';

const SCRUBBER_EDGE_THRESHOLD_PERCENT = 8;

export const formatDopplerFrameTime = (frameTime) =>
  frameTime instanceof Date && Number.isFinite(frameTime.getTime())
    ? frameTime
        .toLocaleTimeString(undefined, {
          hour: 'numeric',
          minute: '2-digit',
        })
        .replace(/\s/g, '\u00A0')
    : '';

export const getDopplerScrubberLabelPosition = (frameIndex, frameCount) => {
  const lastFrameIndex = Math.max(frameCount - 1, 0);
  const boundedFrameIndex = getBoundedValue(Number(frameIndex) || 0, 0, lastFrameIndex);
  const progressPercent = lastFrameIndex > 0 ? (boundedFrameIndex / lastFrameIndex) * 100 : 0;

  if (progressPercent <= SCRUBBER_EDGE_THRESHOLD_PERCENT) {
    return { left: '0%', transform: 'translateX(0)' };
  }

  if (progressPercent >= 100 - SCRUBBER_EDGE_THRESHOLD_PERCENT) {
    return { left: '100%', transform: 'translateX(-100%)' };
  }

  return { left: `${progressPercent}%`, transform: 'translateX(-50%)' };
};

export const getDopplerLoadingDetails = ({
  showViewLoadingOverlay = false,
  viewLoadingReason = null,
  startupReadyFrameCount = 0,
  startupTargetFrameCount = 0,
} = {}) => {
  if (showViewLoadingOverlay) {
    return viewLoadingReason === 'refining' ? 'Loading sharper tiles' : 'Waiting for map to settle';
  }

  return startupTargetFrameCount > 0
    ? `Frames ready: ${startupReadyFrameCount}/${startupTargetFrameCount}`
    : 'Preparing radar frames';
};
